import React from 'react';

import Header from './Header';
import {StickyHeaderProvider} from './StickyHeaderContext';

export default function PageContainer({
  isPublic = false,
  children,
}: {
  isPublic?: boolean;
  children: JSX.Element | (JSX.Element | JSX.Element[] | undefined | string | boolean)[];
}) {
  return (
    <StickyHeaderProvider>
      <Header isPublic={isPublic} />
      <div className="container mx-auto my-4 lg:px-4 px-2">{children}</div>
    </StickyHeaderProvider>
  );
}
